import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import Select from 'react-select';

// * Styling the package and its children
export const StyledSelect = styled(Select)`
  width: 100%;
  margin: 12.5px 0;

  // * The main control div
  .react-select__control {
    border: none;
    border-radius: 0px;
    justify-content: flex-start;
    cursor: pointer;
  }

  .react-select__control--is-disabled {
    cursor: not-allowed;
    pointer-events: auto;
    background-color: ${themeGet('colors.pale-grey')};
    color: ${themeGet('colors.grey')};
  }

  // * Placeholder styling
  .react-select__placeholder {
    color: #000000;
    font-family: ${themeGet('fonts.primary')};
    font-size: 18px;
    font-weight: 600;
    letter-spacing: -0.35px;
    line-height: 38px;
  }

  // * Vertical line that seperates the placeholder from the indicator
  .react-select__indicator-separator {
    display: none;
  }

  .react-select__option,
  .react-select__single-value {
    color: #000000;
    font-family: ${themeGet('fonts.primary')};
    font-size: 18px;
    font-weight: 600;
    letter-spacing: -0.35px;
    line-height: 38px;
  }

  .react-select__menu {
    /* width: 500px; */
    width: 350px;
    z-index: 2;
  }

  .react-select__menu-list {
    z-index: 2;
  }

  .react-select__option {
    padding: 10px;
    &:hover,
    &:focus {
      background-color: rgba(230, 236, 239, 0.4);
    }
  }

  .react-select__option--is-selected {
    background-color: #e6ecef;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    max-width: 399px;
    margin: 0 12.5px 0 0;
  }
`;
